{
  "GENERAL": {
    "CLOSE": "Κλείσιμο",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Αναζήτηση",
      "EMPTY_STATE": "Δεν βρέθηκαν αποτελέσματα"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Απαιτούνται τουλάχιστον {count}"
  }
}
